export default __webpack_public_path__ + "static/media/vision.067d4ae1.png";